export const GET_IMAGE = 'GET_IMAGE'
export const REMOVE_IMAGE = 'REMOVE_IMAGE'
export const PRELOAD_IMAGE = 'PRELOAD_IMAGE'

export const FETCH_FILE_REQUEST = 'FETCH_FILE_REQUEST'
export const FETCH_FILE_SUCCESS = 'FETCH_FILE_SUCCESS'
export const FETCH_FILE_FAILURE = 'FETCH_FILE_FAILURE'
